import { axios } from '@/plugins/http-axios';
import { Module } from 'vuex';
import { isDopDoc, isRequirementFile } from '@/components/Step3/constants';
import { Vicarious } from '@/features/application-review/ui/types';
import moment, { Moment } from 'moment';

export interface IDocument {
  allowTypes: string;
  description: string;
  digitalDocument: boolean;
  digitalDocumentNumber: string;
  extraId: string;
  fileCount: number;
  fioPassport: null | string;
  id: number;
  maxFileSize: number;
  name: string;
  orderNum: number;
  required: boolean;
  type: string;
  files: IFile[];
  requirements: IRequirement[];
  signatureType: boolean;
  electronicDocument: boolean;
  documentTemplateForRequests: Record<string, string>[];
  canDeleteDocumentThatHasNotPassedValidation: boolean;
  comment?: string;
  requirementDate: string; //Дата Допзапроса, после того как он выполнен. Присваиваем сюда дату любого требования
  requirementId: string; //id Допзапроса, после того как он выполнен

  documentTemplates: Record<string, string>[];
  formInDocx: any;
  compositeId: string; //Фронтовый, нужен для сортировки
  idx: number; //Фронтовый, поряддковый номер документа в массиве, его индекс
  isAttachedFile: boolean; //Фронтовый, есть ли загруженные файлы
  isRequirements: boolean; //Фронтовый, был или есть перезапрос
}

interface IDocumentState {
  id: string;
  documents: IDocument[];
}

export interface IRequirement {
  artifactname: string;
  commentEmployee: string;
  completed: boolean;
  createDate: string;
  fileId: null | string;
  id: string;
  isAttachedFile: boolean;
  validated?: boolean;
}

export interface IResponseFile {
  id: string;
  requirementId: string;
  name: string;
  createDate: string;
  validationDate: string | null;
  validated: null | boolean;
  origName: string;
  size: number;
  requirement: null | IRequirement;
  electroDocumentNumber: string | null;
  req: null | boolean;
  lkbExists: boolean; //был ли файл в ЛКБ/отправлен ранее/был в статусе "проверка документов"
  upload?: boolean;
}

export interface IResponseMchd {
  first: Vicarious;
  second: IResponseFile;
}

export function isResponseFile(obj: any): obj is IResponseFile {
  return typeof obj === 'object' && !(obj instanceof Array);
}

export interface IFile extends IResponseFile {
  doctypeid: number;
  templateId: string;
}
export interface IPayloadAddFileToReq {
  i: number;
  j: number;
  file: IFile;
}
export interface IPayloadAddFileToDoc {
  i: number;
  file: IFile;
}

function deleteRequirement(tDoc: IDocument, reqId: string) {
  const index = tDoc.requirements.findIndex((r) => r.id === reqId);
  tDoc.requirements.splice(index, 1);
}

export default <Module<IDocumentState, any>>{
  namespaced: true,
  state: {
    id: '',
    documents: [],
  },
  mutations: {
    setId(state, id: string = '') {
      state.id = id;
    },
    setDocs(state, docs: IDocument[]) {
      docs.forEach((doc, i) => {
        doc.idx = i;
        doc.allowTypes = '.' + doc.allowTypes.split(',').join(',.');
        //Был или есть перезапрос. Тип документа навсегда считаем перезапросом
        doc.isRequirements = isRequirementFile(doc);
        // doc.isRequirements = Boolean(doc.requirements.length && doc.files.length);
        doc.compositeId = doc.id + doc.name;

        if (doc.requirementDate) {
          doc.requirementDate = moment(doc.requirementDate).format('DD.MM.YYYY HH:mm:ss');
        } else {
          let date = '';
          if (doc.requirements.length) {
            date = doc.requirements[doc.requirements.length - 1]?.createDate;
          } else if (doc.isRequirements && doc.files.length) {
            const d = doc.files.reduce<Moment | null>((latest, file) => {
              if (!file.requirement) return latest;

              const currentDate = moment(file.requirement.createDate, 'DD.MM.YYYY HH:mm:ss');
              if (!latest || currentDate > latest) {
                return currentDate;
              }
              return latest;
            }, null);

            date = d ? d.format('DD.MM.YYYY HH:mm:ss') : '';
          }
          doc.requirementDate = date;
        }

        doc.isAttachedFile = !!doc.digitalDocumentNumber || !!doc.files.length; //Ниже более правильный вариант
        // doc.isAttachedFile = !!doc.digitalDocumentNumber || doc.files.some((f) => !f.requirement);

        doc.files.sort((a, b) => {
          const aId = a.requirementId || '';
          const bId = b.requirementId || '';
          return (
            aId.localeCompare(bId) ||
            moment(a.createDate, 'DD.MM.YYYY HH:mm').valueOf() - moment(b.createDate, 'DD.MM.YYYY HH:mm').valueOf()
          );
        });
      });

      state.documents = docs;
    },
    setDigitalDoc(state, { i, number }: { i: number; number: string }) {
      const _doc = state.documents.find((item) => item.idx === i);
      if (_doc) {
        _doc.digitalDocumentNumber = number;
        const attach = !!number;
        _doc.isAttachedFile = !attach && !!_doc.files.length ? true : attach;
      }
    },
    addFile(state, data: { idx: number; files: IFile[] }) {
      const { idx, files } = data;
      const tDoc = state.documents[idx];
      let file = {} as IFile;
      if (files.length === 1) {
        file = files[0];
      }

      if (file.requirement?.id) {
        const requirementId = file.requirement?.id;
        const fileReq = tDoc.files.find((file) => file.requirement?.id == requirementId);
        if (fileReq?.requirement) {
          //Перезапрос
          fileReq.requirement.completed = true;
          const index = tDoc.files.indexOf(fileReq);
          // console.log(1, requirementId, index);
          tDoc.files.splice(index + 1, 0, file);
        } else {
          //Допзапрос
          // console.log(333.1);
          tDoc.files = [...tDoc.files, file];
          tDoc.isRequirements = true;
        }
        deleteRequirement(tDoc, file.requirement.id);
        //@ts-ignore
        delete file.requirement;
      } else {
        //Обычный тип документа
        // console.log(333.2);
        tDoc.files = [...tDoc.files, ...files];
      }
      tDoc.isAttachedFile = true;
      // state.documents.splice(idx, 1, tDoc);
      // console.log(222, state.documents[idx].files);
    },
    deleteFile(state, fileId: string) {
      let file: IFile | undefined;
      let tDoc: IDocument | undefined;
      for (let i = 0; i < state.documents.length && !file; i++) {
        tDoc = state.documents[i];
        file = tDoc.files.find((file) => file.id == fileId);
      }
      if (file && tDoc) {
        const index = tDoc.files.indexOf(file);
        tDoc.files.splice(index, 1);
        tDoc.isAttachedFile = !!tDoc.files.length;
      }
    },
  },
  actions: {
    async getDocuments({ commit, dispatch, rootGetters }, id = rootGetters.appId): Promise<IDocument[]> {
      if (id) {
        return axios
          .get<IDocument[]>(rootGetters.uri.documents(id))
          .then((resp) => {
            const docs = resp.data || [];
            // const docs = (resp.data || [])
            //     .sort((a, b) => {
            //       return a.orderNum - b.orderNum;
            //     })
            //     .sort((a, b) => {
            //       if (getters.isRequirementDoc(a)) return -1;
            //       if (getters.isRequirementDoc(b)) return 1;
            //       return 0;
            //     });

            commit('setDocs', docs);
            return resp.data;
          })
          .catch((e) => {
            e.uri = rootGetters.uri.documents(id);
            dispatch('setError', e, { root: true });
            return Promise.reject(e);
          });
      } else {
        const e = new Error('Нет id');
        dispatch('setError', e, { root: true });
        return Promise.reject(e);
      }
    },
    async processingRequirements({ commit, dispatch, getters, rootGetters }): Promise<void> {
      if (rootGetters.appId != getters.oldId) {
        commit('setId', rootGetters.appId);
        await dispatch('getDocuments');
      }
      return Promise.resolve();
    },
  },
  getters: {
    docs: (state): IDocument[] => state.documents,
    documentsRequired: (state): IDocument[] =>
      state.documents.filter((doc) => (doc.required || doc.isRequirements) && !doc.signatureType),
    documentsNotRequired: (state): IDocument[] =>
      state.documents.filter((doc) => !doc.required && !doc.isRequirements && !doc.signatureType),
    oldId: (state): string => state.id,
    isRequirementDoc:
      (state, getters, rootState, rootGetters) =>
      (doc: IDocument): boolean => {
        return (
          /*doc.required && !doc.files.length ||*/ rootGetters.isAddDocs && (isDopDoc(doc) || isRequirementFile(doc))
        );
      },
  },
};
